import { render, staticRenderFns } from "./CollectPaymentModal.vue?vue&type=template&id=6199f8a7&scoped=true&"
import script from "./CollectPaymentModal.vue?vue&type=script&lang=js&"
export * from "./CollectPaymentModal.vue?vue&type=script&lang=js&"
import style0 from "./CollectPaymentModal.vue?vue&type=style&index=0&id=6199f8a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6199f8a7",
  null
  
)

component.options.__file = "CollectPaymentModal.vue"
export default component.exports